import { Navigate } from "react-router-dom";

export default function AuthGuard({ children }) {
  const uid = localStorage.getItem("uid");

  if (!uid) {
    return <Navigate to="/login" replace />;
  }

  return children;
}